const page_schema = {
	"tiers": [
		{
			"name": "d-none",
			"type": "checkbox",
			"id": "d-none",
			"class_name": "tags",
			"child_name": "d-none",
			"options": [
				{
					"name": "Enzymes & Protein Expression",
					"id": "enzymes-and-protein-expression"
				},
				{
					"name": "Nucleases",
					"id": "nucleases"
				},
				{
					"name": "Proteases",
					"id": "proteases"
				},
				{
					"name": "Lytic Enzymes",
					"id": "lytic-enzymes"
				},
				{
					"name": "Protein Expression & Purification",
					"id": "protein-expression-and-purification"
				},
				{
					"name": "RNase A Collection",
					"id": "rnase-a-collection"
				},
				{
					"name": "DNA Degradase",
					"id": "dna-degradase"
				},
				{
					"name": "Zymolyase Collection",
					"id": "zymolyase-collection"
				},
				{
					"name": "Protein Purification",
					"id": "protein-purification"
				},
				{
					"name": "Epigenetics Enzymes",
					"id": "epigenetics-enzymes"
				},
				{
					"name": "Transposases",
					"id": "transposases"
				}
			]
		},
	],
	"filters": [],
	"products": {
		"Endura Tn5 Transposase": {
			"title": "Endura Tn5 Transposase",
			"catalogNumbers": "E1024-20, E1024-100, E1024-4-5, E1025-20, E1025-100",
			"description": "Endura™ Tn5 Transposase is hyperactive mutant of Tn5 Transposase with a proprietary formulation to confer superior stability, efficient tagmentation, and reliable consistency between experiments.",
			"handle": "/products/endura-tn5-transposase-unloaded",
			"navigation_image": "https://www.zymoresearch.com/cdn/shop/files/Product_Photo_Final_5760x5760.webp?v=1753289559",
			"generalIndex": "998",
			"id": "endura-tn5-transposase-unloaded",
			"tags": [
				"transposases",
				"enzymes-and-protein-expression",
				"epigenetics-enzymes",
			],
			filters: []
		},
		"PureRec RNase A (Recombinant)": {
			"title": "PureRec RNase A (Recombinant)",
			"catalogNumbers": "E1019T, E1019-5, E1019-20",
			"description": "RNase A is a very active endoribonuclease that digests RNA in a wide range of buffer conditions and temperatures.",
			"handle": "/products/purerec-rnase-a-recombinant",
			"navigation_image": "https://www.zymoresearch.com/cdn/shop/files/E1019T-purerec_rnasea_1mg_5760x5760.png?v=1713561152",
			"generalIndex": "998",
			"id": "purerec-rnase-a-recombinant",
			"tags": [
				"enzymes-and-protein-expression",
				"nucleases",
				"rnase-a-collection",
			],
			filters: []
		},
		"DNase I Set (RNase-free)": {
			"title": "DNase I Set (RNase-free)",
			"catalogNumbers": "E1010, E1011, E1012",
			"description": "Zymo Research DNase I is a recombinant endonuclease that cleaves single- and double-stranded DNA.",
			"handle": "/products/dnase-i-set",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/E1010_DNase-I-Set-lyophilized.jpg?v=1628532368&width=600",
			"generalIndex": "998",
			"id": "dnase-i-set",
			"tags": [
				"enzymes-and-protein-expression",
				"nucleases",
			],
			filters: []
		},
		"RNase A (DNase-free)": {
			"title": "RNase A (DNase-free)",
			"catalogNumbers": "E1008-30",
			"description": "RNase A is a highly active and stable enzyme that specifically digests RNA across a wide range of buffer conditions and temperatures.",
			"handle": "/products/rnase-a",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/E1008-30_RNaseA-30mg.png?v=1676407572&width=600",
			"generalIndex": "998",
			"id": "rnase-a",
			"tags": [
				"enzymes-and-protein-expression",
				"nucleases",
				"rnase-a-collection",
			],
			filters: []
		},
		"Micrococcal Nuclease": {
			"title": "Micrococcal Nuclease",
			"catalogNumbers": "D5220-1",
			"description": "Micrococcal Nuclease cleaves single-stranded and double-stranded DNA and RNA.",
			"handle": "/products/micrococcal-nuclease",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5220-1_Micrococcal-Nuclease.jpg?v=1628532397&width=600",
			"generalIndex": "998",
			"id": "micrococcal-nuclease",
			"tags": [
				"enzymes-and-protein-expression",
				"epigenetics-enzymes",
				"nucleases",
			],
			filters: []
		},
		"DNA Degradase Plus": {
			"title": "DNA Degradase Plus",
			"catalogNumbers": "E2020, E2021",
			"description": "DNA Degradase Plus from Zymo Research is a nuclease mix that quickly and efficiently degrades DNA to its individual nucleoside components.",
			"handle": "/products/dna-degradase-plus",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/E2020_DNA-Degradase-Plus.jpg?v=1628532404&width=600",
			"generalIndex": "998",
			"id": "dna-degradase-plus",
			"tags": [
				"enzymes-and-protein-expression",
				"nucleases",
				"dna-degradase",
				"epigenetics-enzymes",
			],
			filters: []
		},
		"dsDNA Shearase Plus": {
			"title": "dsDNA Shearase Plus",
			"catalogNumbers": "E2018-50, E2018-200",
			"description": "dsDNA Shearase Plus is an endonuclease that cleaves phosphodiester bonds in DNA to yield oligonucleotides with 5’-phosphate and 3’-hydroxyl termini.",
			"handle": "/products/dsdna-shearase-plus",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/E2018-50_dsDNA-Shearase-Plus-50-U.jpg?v=1628532407&width=600",
			"generalIndex": "998",
			"id": "dsdna-shearase-plus",
			"tags": [
				"enzymes-and-protein-expression",
				"nucleases",
				"epigenetics-enzymes",
			],
			filters: []
		},
		"Atlantis dsDNase": {
			"title": "Atlantis dsDNase",
			"catalogNumbers": "E2030",
			"description": "Atlantis dsDNase is a double-stranded DNA-specific endonuclease that cleaves phosphodiester bonds in DNA to yield homogeneous populations of core nucleosomes.",
			"handle": "/products/atlantis-ds-dnase",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/E2030_Atlantis-dsDNase-12.5-U.jpg?v=1628532394&width=600",
			"generalIndex": "998",
			"id": "atlantis-ds-dnase",
			"tags": [
				"enzymes-and-protein-expression",
				"nucleases",
				"epigenetics-enzymes",
			],
			filters: []
		},
		"DNA Degradase": {
			"title": "DNA Degradase",
			"catalogNumbers": "E2016, E2017",
			"description": "DNA Degradase from Zymo Research is a nuclease mix that quickly and efficiently degrades DNA to its individual nucleotide components.",
			"handle": "/products/dna-degradase",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/E2016_DNA-Degradase.jpg?v=1628532393&width=600",
			"generalIndex": "998",
			"id": "dna-degradase",
			"tags": [
				"enzymes-and-protein-expression",
				"nucleases",
				"dna-degradase",
				"epigenetics-enzymes",
			],
			filters: []
		},
		"PureRec Duplex-Specific Nuclease (DSN)": {
			"title": "PureRec Duplex-Specific Nuclease (DSN)",
			"catalogNumbers": "E1020-200, E1020-1000",
			"description": "PureRec Duplex-Specific Nuclease (DSN) is an endonuclease that selectively digests double-stranded DNA (dsDNA) and DNA in DNA-RNA hybrids, exhibiting virtually no activity towards single-stranded DNA (ssDNA) or RNA.",
			"handle": "/products/purerec-duplex-specific-nuclease-dsn",
			"navigation_image": "https://www.zymoresearch.com/cdn/shop/files/E1020-200_9182b_5760x5760.jpg?v=1716918857",
			"generalIndex": "998",
			"id": "purerec-duplex-specific-nuclease-dsn",
			"tags": [
				"enzymes-and-protein-expression",
				"nucleases",
			],
			filters: []
		},
		"Proteinase K w/ Storage Buffer Set": {
			"title": "Proteinase K w/ Storage Buffer Set",
			"catalogNumbers": "D3001-2-5, D3001-2-20, D3001-2-60, D3001-2-125",
			"description": "Proteinase K is a stable serine protease with broad substrate specificity and will degrade many proteins in their native conformation even in the presence of detergents (e.g., SDS).",
			"handle": "/products/proteinase-k-w-storage-buffer-set",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D3001-2-20_Proteinase-K-lyophilized-20-mg_06c54e96-c4f3-4af5-9261-8421d2550503.jpg?v=1628532360&width=600",
			"generalIndex": "998",
			"id": "proteinase-k-w-storage-buffer-set",
			"tags": [
				"enzymes-and-protein-expression",
				"proteases",
			],
			filters: []
		},
		"Zymolyase Ultra": {
			"title": "Zymolyase Ultra",
			"catalogNumbers": "E1007T, E1007-2, E1007-10",
			"description": "An optimized enzyme formulation for efficient yeast cell wall digestion, targeting multiple wall components. It is highly purified with DNA/RNA removal technology to deliver ultra-low nucleic acid contamination.",
			"handle": "/products/zymolyase-ultra",
			"navigation_image": "https://www.zymoresearch.com/cdn/shop/files/E1007T-Zymolyase-100-U_a70918fd-fa44-4b59-b2a4-7cb354961c54_5760x5760.jpg?v=1713477194",
			"generalIndex": "998",
			"id": "zymolyase-ultra",
			"tags": [
				"enzymes-and-protein-expression",
				"lytic-enzymes",
				"zymolyase-collection",
			],
			filters: []
		},
		"Zymolyase": {
			"title": "Zymolyase",
			"catalogNumbers": "E1006, E1005, E1004",
			"description": "Digestion of yeast and fungal cell walls is necessary for many experimental procedures including spheroplasting, immunofluorescence, transformation, protein purification, and others.",
			"handle": "/products/zymolyase",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/E1005_Zymolayse-2000-U_d0db7f0b-6855-496b-bec6-e1d916a0bbf5.jpg?v=1628532375&width=600",
			"generalIndex": "998",
			"id": "zymolyase",
			"tags": [
				"enzymes-and-protein-expression",
				"lytic-enzymes",
				"zymolyase-collection",
			],
			filters: []
		},
		"ZymoTaq PreMix": {
			"title": "ZymoTaq PreMix",
			"catalogNumbers": "E2003, E2004",
			"description": "ZymoTaq PreMix is supplied as a 2X concentrated “master mix” containing all the reagents needed to perform “hot start” PCR.",
			"handle": "/collections/zymotaq-polymerase/products/zymotaq-premix",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/E2003_ZymoTaq-PreMix.jpg?v=1628532368&width=600",
			"generalIndex": "998",
			"id": "zymotaq-premix",
			"tags": [
				"enzymes-and-protein-expression",
				"epigenetics-enzymes",
			],
			filters: []
		},
		"ZymoTaq DNA Polymerase": {
			"title": "ZymoTaq DNA Polymerase",
			"catalogNumbers": "E2001, E2002",
			"description": "ZymoTaq DNA Polymerase contains all the reagents needed to perform “hot-start” PCR.",
			"handle": "/collections/zymotaq-polymerase/products/zymotaq-dna-polymerase",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/E2001_ZymoTaq-Polymerase.jpg?v=1628532372&width=600",
			"generalIndex": "998",
			"id": "zymotaq-dna-polymerase",
			"tags": [
				"enzymes-and-protein-expression",
				"epigenetics-enzymes",
			],
			filters: []
		},
		"ZymoTaq qPCR Premix": {
			"title": "ZymoTaq qPCR Premix",
			"catalogNumbers": "E2054, E2055",
			"description": "ZymoTaq qPCR PreMix contains all the reagents needed to perform quantitative PCR and other molecular downstream analysis such as high-resolution melt (HRM) analysis of DNA methylation and other general real-time PCR assays.",
			"handle": "/collections/zymotaq-polymerase/products/zymotaq-qpcr-premix",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/E2054_ZymoTaq-qPCR-Premix.jpg?v=1628532408&width=600",
			"generalIndex": "998",
			"id": "zymotaq-qpcr-premix",
			"tags": [
				"enzymes-and-protein-expression",
				"epigenetics-enzymes",
			],
			filters: []
		},
		"CpG Methylase (M. Sssl)": {
			"title": "CpG Methylase (M. Sssl)",
			"catalogNumbers": "E2010, E2011",
			"description": "CpG Methylase completely methylates all cytosines in double-stranded, non-methylated, and hemimethylated DNA in a 5'...CpG...3' context.",
			"handle": "/products/cpg-methylase-m-sssl",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/E2010_CpG-Methylase.jpg?v=1628532396&width=600",
			"generalIndex": "998",
			"id": "cpg-methylase-m-sssl",
			"tags": [
				"enzymes-and-protein-expression",
				"epigenetics-enzymes",
			],
			filters: []
		},
		"5-hmC Glucosyltransferase": {
			"title": "5-hmC Glucosyltransferase",
			"catalogNumbers": "E2026, E2027",
			"description": "The 5-hmC Glucosyltransferase is a highly active enzyme that specifically tags 5-hydroxymethylcytosine in DNA with a glucose moiety to yield glucosyl-5-hydroxymethylcytosine, which in turn can be used for sequence-specific, genome-wide, or global 5-hmC detection.",
			"handle": "/products/5-hmc-glucosyltransferase",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/E2026_5-hmC-Glucosyltransferase.jpg?v=1628532397&width=600",
			"generalIndex": "998",
			"id": "5-hmc-glucosyltransferase",
			"tags": [
				"enzymes-and-protein-expression",
				"epigenetics-enzymes",
			],
			filters: []
		},
		"5-Methyl dCTP": {
			"title": "5-Methyl dCTP",
			"catalogNumbers": "D1035",
			"description": "5-Methyl dCTP can be used in nucleotide mixtures to generate PCR amplicons using ZymoTaq, QuestTaq, or other DNA polymerases.",
			"handle": "/collections/methylated-nucleotides/products/5-methyl-dctp",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D1035_Methylated-and-Hydroxymethylated-Nucleotides.jpg?v=1628532399&width=600",
			"generalIndex": "998",
			"id": "5-methyl-dctp",
			"tags": [
				"enzymes-and-protein-expression",
				"epigenetics-enzymes",
			],
			filters: []
		},
		"5-Methylcytosine dNTP Mix": {
			"title": "5-Methylcytosine dNTP Mix",
			"catalogNumbers": "D1030",
			"description": "Highly pure 5-Methylcytosine dNTP Mix that can be used to generate PCR amplicons using ZymoTaq, QuestTaq, or other DNA polymerases.",
			"handle": "/collections/methylated-nucleotides/products/5-methylcytosine-dntp-mix",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D1030_Methylated-and-Hydroxymethylated-Nucleotides.jpg?v=1628532404&width=600",
			"generalIndex": "998",
			"id": "5-methylcytosine-dntp-mix",
			"tags": [
				"enzymes-and-protein-expression",
				"epigenetics-enzymes",
			],
			filters: []
		},
		"dNTP Mix": {
			"title": "dNTP Mix",
			"catalogNumbers": "D1000, D1000-1",
			"description": "dNTP Mix is a ready-to-use, ultra pure nucleotide mix that can be used to generate PCR amplicons using ZymoTaq, QuestTaq or other DNA polymerases.",
			"handle": "/collections/dntp-solutions/products/dntp-mix",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D1000_dNTPs.jpg?v=1628532404&width=600",
			"generalIndex": "998",
			"id": "dntp-mix",
			"tags": [
				"enzymes-and-protein-expression",
				"epigenetics-enzymes",
			],
			filters: []
		},
		"dATP": {
			"title": "dATP",
			"catalogNumbers": "D1005",
			"description": "Ultra pure dATP can be used in nucleotide mixtures to generate PCR amplicons using ZymoTaq, QuestTaq or other DNA polymerases.",
			"handle": "/collections/dntp-solutions/products/datp",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D1005_dATP.jpg?v=1628532405&width=600",
			"generalIndex": "998",
			"id": "datp",
			"tags": [
				"enzymes-and-protein-expression",
				"epigenetics-enzymes",
			],
			filters: []
		},
		"dCTP": {
			"title": "dCTP",
			"catalogNumbers": "D1020",
			"description": "Ultra pure dCTP can be used in nucleotide mixtures to generate PCR amplicons using ZymoTaq, QuestTaq or other DNA polymerases.",
			"handle": "/collections/dntp-solutions/products/dctp",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D1020_dCTP.jpg?v=1628532398&width=600",
			"generalIndex": "998",
			"id": "dctp",
			"tags": [
				"enzymes-and-protein-expression",
				"epigenetics-enzymes",
			],
			filters: []
		},
		"dTTP": {
			"title": "dTTP",
			"catalogNumbers": "D1010",
			"description": "Ultra pure dTTP can be used in nucleotide mixtures to generate PCR amplicons using ZymoTaq, QuestTaq or other DNA polymerases.",
			"handle": "/collections/dntp-solutions/products/dttp",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D1010_dTTP.jpg?v=1628532407&width=600",
			"generalIndex": "998",
			"id": "dttp",
			"tags": [
				"enzymes-and-protein-expression",
				"epigenetics-enzymes",
			],
			filters: []
		},
		"dGTP": {
			"title": "dGTP",
			"catalogNumbers": "D1015",
			"description": "Ultra pure dGTP can be used in nucleotide mixtures to generate PCR amplicons using ZymoTaq, QuestTaq or other DNA polymerases.",
			"handle": "/collections/dntp-solutions/products/dgtp",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D1015_dGTP.jpg?v=1628532393&width=600",
			"generalIndex": "998",
			"id": "dgtp",
			"tags": [
				"enzymes-and-protein-expression",
				"epigenetics-enzymes",
			],
			filters: []
		},
		"Mix & Go! Competent Cells - DH5 Alpha": {
			"title": "Mix & Go! Competent Cells - DH5 Alpha",
			"catalogNumbers": "T3007, T3009, T3010",
			"description": "The Mix & Go! Competent Cells - DH5 Alpha are premade <i>E. coli</i> DH5 alpha competent cells for simple and highly efficient DNA transformation.",
			"handle": "/products/mix-and-go-competent-cells-dh5-alpha",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/T3009_Mix-and-Go-Competent-Cells---Zymo-5a.jpg?v=1650383686&width=600",
			"generalIndex": "998",
			"id": "mix-and-go-competent-cells-dh5-alpha",
			"tags": [
				"enzymes-and-protein-expression",
				"protein-expression-and-purification",
			],
			filters: []
		},
		"Mix & Go! Competent Cells - Zymo 10B": {
			"title": "Mix & Go! Competent Cells - Zymo 10B",
			"catalogNumbers": "T3019, T3020",
			"description": "The Mix & Go! <i>E. coli</i> strains are premade, chemically competent cells for simple and highly efficient DNA transformation.",
			"handle": "/products/mix-and-go-competent-cells-zymo-10b",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/T3013_Mix-and-Go-Competent-Cells---Zymo-10B.jpg?v=1650383709&width=600",
			"generalIndex": "998",
			"id": "mix-and-go-competent-cells-zymo-10b",
			"tags": [
				"enzymes-and-protein-expression",
				"protein-expression-and-purification",
			],
			filters: []
		},
		"Mix & Go! Competent Cells - JM109": {
			"title": "Mix & Go! Competent Cells - JM109",
			"catalogNumbers": "T3003, T3005",
			"description": "The Mix & Go! <i>E. coli</i> strains are premade, chemically competent cells for simple and highly efficient DNA transformation.",
			"handle": "/products/mix-and-go-competent-cells-jm109",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/T3005_Mix-and-Go-Competent-Cells---JM109.jpg?v=1650383662&width=600",
			"generalIndex": "998",
			"id": "mix-and-go-competent-cells-jm109",
			"tags": [
				"enzymes-and-protein-expression",
				"protein-expression-and-purification",
			],
			filters: []
		},
		"Mix & Go! Competent Cells - HB101": {
			"title": "Mix & Go! Competent Cells - HB101",
			"catalogNumbers": "T3011, T3013",
			"description": "The Mix & Go! <i>E. coli</i> strains are premade, chemically competent cells for simple and highly efficient DNA transformation.",
			"handle": "/products/mix-and-go-competent-cells-hb101",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/T3013_Mix-and-Go-Competent-Cells---HB101.jpg?v=1650383625&width=600",
			"generalIndex": "998",
			"id": "mix-and-go-competent-cells-hb101",
			"tags": [
				"enzymes-and-protein-expression",
				"protein-expression-and-purification",
			],
			filters: []
		},
		"Mix & Go! Competent Cells - TG1": {
			"title": "Mix & Go! Competent Cells - TG1",
			"catalogNumbers": "T3017",
			"description": "The Mix & Go! <i>E. coli</i> strains are premade, chemically competent cells for simple and highly efficient DNA transformation.",
			"handle": "/products/mix-and-go-competent-cells-tg1",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/T3017_Mix_20_20Go_20Competent_20Cells_20-_20TG1_20Tubes_20x10_ffbade76-8e21-4794-92e5-2d7a768d5dc8.png?v=1628532404&width=600",
			"generalIndex": "998",
			"id": "mix-and-go-competent-cells-tg1",
			"tags": [
				"enzymes-and-protein-expression",
				"protein-expression-and-purification",
			],
			filters: []
		},
		"Mix & Go! XJb (DE3) Autolysis Competent Cells": {
			"title": "Mix & Go! XJb (DE3) Autolysis Competent Cells",
			"catalogNumbers": "T3051",
			"description": "While there are many cell lysis methods available to scientists, unfortunately none of these methods combine all the ideal features for simple, efficient, economical, and gentle lysis of <i>E. coli</i> cells.",
			"handle": "/products/mix-and-go-competent-cells-xjbde3-autolysis",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/T3051_XJb_20DE3_20Autolysis_20-_20Glycerol_20Stock_20-_201_20ml_20x_2010.png?v=1628532394&width=600",
			"generalIndex": "998",
			"id": "mix-and-go-competent-cells-xjbde3-autolysis",
			"tags": [
				"enzymes-and-protein-expression",
				"protein-expression-and-purification",
			],
			filters: []
		},
		"Mix & Go! XJb Autolysis Competent Cells": {
			"title": "Mix & Go! XJb Autolysis Competent Cells",
			"catalogNumbers": "T3041",
			"description": "While there are many cell lysis methods available to scientists, unfortunately none of these methods combine all the ideal features for simple, efficient, economical, and gentle lysis of <i>E. coli</i> cells.",
			"handle": "/products/mix-and-go-competent-cells-xjb-autolysis",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/T3041_XJb_20Autolysis_20-_20Glycerol_20Stock_20-_201_20ml_20x_2010.png?v=1628532393&width=600",
			"generalIndex": "998",
			"id": "mix-and-go-competent-cells-xjb-autolysis",
			"tags": [
				"enzymes-and-protein-expression",
				"protein-expression-and-purification",
			],
			filters: []
		},
		"XJb Autolysis Glycerol Stock": {
			"title": "XJb Autolysis Glycerol Stock",
			"catalogNumbers": "T5041",
			"description": "While there are many cell lysis methods available to scientists, unfortunately none of these methods combine all the ideal features for simple, efficient, economical, and gentle lysis of <i>E. coli</i> cells.",
			"handle": "/products/xjb-autolysis-glycerol-stock",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/T5041_XJb_20Autolysis_20-_20Glycerol_20Stock_20-_201_20ml.png?v=1628532396&width=600",
			"generalIndex": "998",
			"id": "xjb-autolysis-glycerol-stock",
			"tags": [
				"enzymes-and-protein-expression",
				"protein-expression-and-purification",
			],
			filters: []
		},
		"Mix & Go! XJa Autolysis Competent Cells": {
			"title": "Mix & Go! XJa Autolysis Competent Cells",
			"catalogNumbers": "T3021",
			"description": "While there are many cell lysis methods available to scientists, unfortunately none of these methods combine all the ideal features for simple, efficient, economical, and gentle lysis of <i>E. coli</i> cells.",
			"handle": "/products/mix-and-go-competent-cells-xja-autolysis",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/T3021_XJa_20Autolysis_20-_20Glycerol_20Stock_20-_201_20ml_20x_2010.png?v=1628532405&width=600",
			"generalIndex": "998",
			"id": "mix-and-go-competent-cells-xja-autolysis",
			"tags": [
				"enzymes-and-protein-expression",
				"protein-expression-and-purification",
			],
			filters: []
		},
		"XJa Autolysis Glycerol Stock": {
			"title": "XJa Autolysis Glycerol Stock",
			"catalogNumbers": "T5021",
			"description": "While there are many cell lysis methods available to scientists, unfortunately none of these methods combine all the ideal features for simple, efficient, economical, and gentle lysis of <i>E. coli</i> cells.",
			"handle": "/products/xja-autolysis-glycerol-stock",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/T5021_XJa_20Autolysis_20-_20Glycerol_20Stock_20-_201_20ml.png?v=1628532404&width=600",
			"generalIndex": "998",
			"id": "xja-autolysis-glycerol-stock",
			"tags": [
				"enzymes-and-protein-expression",
				"protein-expression-and-purification",
			],
			filters: []
		},
		"Mix & Go! XJa (DE3) Autolysis Competent Cells": {
			"title": "Mix & Go! XJa (DE3) Autolysis Competent Cells",
			"catalogNumbers": "T3031",
			"description": "While there are many cell lysis methods available to scientists, unfortunately none of these methods combine all the ideal features for simple, efficient, economical, and gentle lysis of <i>E. coli</i> cells.",
			"handle": "/products/mix-and-go-competent-cells-xjade3-autolysis",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/T3031_XJa_20DE3_20Autolysis_20-_20Glycerol_20Stock_20-_201_20ml_20x_2010.png?v=1628532404&width=600",
			"generalIndex": "998",
			"id": "mix-and-go-competent-cells-xjade3-autolysis",
			"tags": [
				"enzymes-and-protein-expression",
				"protein-expression-and-purification",
			],
			filters: []
		},
		"XJa (DE3) Autolysis Glycerol Stock": {
			"title": "XJa (DE3) Autolysis Glycerol Stock",
			"catalogNumbers": "T5031",
			"description": "While there are many cell lysis methods available to scientists, unfortunately none of these methods combine all the ideal features for simple, efficient, economical, and gentle lysis of <i>E. coli</i> cells.",
			"handle": "/products/xjade3-autolysis-glycerol-stock",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/T5031_XJa_20DE3_20Autolysis_20-_20Glycerol_20Stock_20-_201_20ml.png?v=1628532406&width=600",
			"generalIndex": "998",
			"id": "xjade3-autolysis-glycerol-stock",
			"tags": [
				"enzymes-and-protein-expression",
				"protein-expression-and-purification",
			],
			filters: []
		},
		"Mix & Go! E.coli Transformation Kit and Buffer Set": {
			"title": "Mix & Go! E.coli Transformation Kit and Buffer Set",
			"catalogNumbers": "T3001, T3002",
			"description": "The Mix & Go! <i>E. coli</i> Transformation Kit and Mix & Go! <i>E. coli</i> Transformation Buffer Set are convenient methods for the preparation of competent E.",
			"handle": "/products/mix-and-go-e-coli-transformation-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/T3002_Mix-and-Go-E-Coli-Transformation-Buffer-Set.jpg?v=1628532392&width=600",
			"generalIndex": "998",
			"id": "mix-and-go-e-coli-transformation-kit",
			"tags": [
				"enzymes-and-protein-expression",
			],
			filters: []
		},
		"Frozen-EZ Yeast Transformation II Kit": {
			"title": "Frozen-EZ Yeast Transformation II Kit",
			"catalogNumbers": "T2001",
			"description": "The Frozen-EZ Yeast Transformation II Kit is designed to make yeast transformations and library screening easier and more efficient than currently available methods.",
			"handle": "/products/frozen-ez-yeast-transformation-ii-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/T2001_Frozen-EZ-Yeast-Transformation-II-Kit_a3b6e0a9-2ff0-46d3-befa-66d78d61af9b.jpg?v=1628532360&width=600",
			"generalIndex": "998",
			"id": "frozen-ez-yeast-transformation-ii-kit",
			"tags": [
				"enzymes-and-protein-expression",
				"protein-expression-and-purification",
			],
			filters: []
		},
		"Yeast Protein Kit": {
			"title": "Yeast Protein Kit",
			"catalogNumbers": "Y1002",
			"description": "The Yeast Protein Kit is a simple and convenient method for the rapid and thorough lysis of yeast cells.",
			"handle": "/products/yeast-protein-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/Y1002_Yeast-Protein-Kit_215fe0f5-a528-45d4-9e60-5c0ffc0a05ca.jpg?v=1628532367&width=600",
			"generalIndex": "998",
			"id": "yeast-protein-kit",
			"tags": [
				"enzymes-and-protein-expression",
				"protein-expression-and-purification",
				"protein-purification",
			],
			filters: []
		},
		"His-Spin Protein Miniprep": {
			"title": "His-Spin Protein Miniprep",
			"catalogNumbers": "P2001, P2002",
			"description": "The His-Spin Protein Miniprep provides a fast spin-column based purification technology for His-tagged proteins.",
			"handle": "/products/his-spin-protein-miniprep",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/P2002_His-Spin-Protein-Miniprep-Kit_60b5bd96-f134-4a2f-bdc7-204d6a851b5e.jpg?v=1628532371&width=600",
			"generalIndex": "998",
			"id": "his-spin-protein-miniprep",
			"tags": [
				"enzymes-and-protein-expression",
				"protein-expression-and-purification",
				"protein-purification",
			],
			filters: []
		},
		"Dual Media Set": {
			"title": "Dual Media Set",
			"catalogNumbers": "M3011",
			"description": "Although recombinant protein expression in <i>E. coli</i> has become all but routine, high level protein expression or over-expression is not always consistent and repeatable for every protein.",
			"handle": "/products/dual-media-set",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/M3011_Dual-Media-Set-100-mL-EB-500-mL-OB.jpg?v=1628532386&width=600",
			"generalIndex": "998",
			"id": "dual-media-set",
			"tags": [
				"enzymes-and-protein-expression",
				"protein-expression-and-purification",
			],
			filters: []
		},
		"DNA Clean & Concentrator MagBead Kit": {
			"title": "DNA Clean & Concentrator MagBead Kit",
			"catalogNumbers": "D4012",
			"description": "The DNA Clean & Concentrator MagBead Kit is magnetic bead based clean-up kit that can purify DNA from PCR, enzymatic reactions, impure extractions, and other sources.",
			"handle": "/products/dna-clean-concentrator-magbead-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4012_DNA-Clean-_-Concentrator-Magbead.jpg?v=1643046391&width=600",
			"generalIndex": "998",
			"id": "dna-clean-concentrator-magbead-kit",
			"tags": [
				"enzymes-and-protein-expression",
				"protein-expression-and-purification",
			],
			filters: []
		},
		"DNA Clean & Concentrator-5": {
			"title": "DNA Clean & Concentrator-5",
			"catalogNumbers": "D4004, D4003, D4014, D4013, D4003T",
			"description": "The DNA Clean & Concentrator-5 is a PCR purification kit that provides purification of up to 5 µg DNA from PCR, endonuclease digestions, DNA modification reactions, isotope/fluorescence labeling reactions, etc.",
			"handle": "/products/dna-clean-concentrator-5",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4003_DNA-Clean-and-Concentrator-5_d3bd0105-e601-4e88-a4da-04484d8bab7b.jpg?v=1628532365&width=600",
			"generalIndex": "998",
			"id": "dna-clean-concentrator-5",
			"tags": [
				"enzymes-and-protein-expression",
				"protein-expression-and-purification",
			],
			filters: []
		},
		"DNA Clean & Concentrator-25": {
			"title": "DNA Clean & Concentrator-25",
			"catalogNumbers": "D4005, D4006, D4033, D4034",
			"description": "The DNA Clean & Concentrator-25 (DCC-25) is a PCR purification kit designed for rapid desalting and purification of up to 25 µg DNA from enzymatic reactions (e.g., PCR), endonuclease digestions, or cell-free lysates.",
			"handle": "https://stage.zymoresearch.com/products/dna-clean-concentrator-25",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4005-DNA-Clean-_-Concentrator-25.jpg?v=1628532371&width=600",
			"generalIndex": "998",
			"id": "dna-clean-concentrator-25",
			"tags": [
				"protein-expression-and-purification",
			],
			filters: []
		},
		"DNA Clean & Concentrator-100": {
			"title": "DNA Clean & Concentrator-100",
			"catalogNumbers": "D4029, D4030",
			"description": "The DNA Clean & Concentrator-100 (DCC-100) is a PCR purification kit designed for the rapid desalting and purification of up to 100 µg of high quality DNA from PCR, large format restriction endonuclease digestions, or cell-free lysates.",
			"handle": "https://stage.zymoresearch.com/products/dna-clean-concentrator-100",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4029_DNA-Clean-and-Concentrator-100-Kit.jpg?v=1628532369&width=600",
			"generalIndex": "998",
			"id": "dna-clean-concentrator-100",
			"tags": [
				"protein-expression-and-purification",
			],
			filters: []
		},
		"DNA Clean & Concentrator-500": {
			"title": "DNA Clean & Concentrator-500",
			"catalogNumbers": "D4031, D4032",
			"description": "The DNA Clean & Concentrator-500 (DCC-500) is our highest capacity PCR purification kit of the DNA Clean & Concentrator products.",
			"handle": "https://stage.zymoresearch.com/products/dna-clean-concentrator-500",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4031-DNA-Clean-_-Concentrator--500.jpg?v=1628532352&width=600",
			"generalIndex": "998",
			"id": "dna-clean-concentrator-500",
			"tags": [
				"protein-expression-and-purification",
			],
			filters: []
		},
		"ZR-96 DNA Clean-Up Kit": {
			"title": "ZR-96 DNA Clean-Up Kit",
			"catalogNumbers": "D4017, D4018",
			"description": "The ZR-96 DNA Clean-up Kit is a PCR purification kit that provides for rapid, large-scale (96-well) purification and concentration of high-quality DNA from PCR samples, endonuclease digestions, or crude plasmid preparations.",
			"handle": "/products/zr-96-dna-clean-up-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4017_ZR-96-DNA-Clean-up-Kit.jpg?v=1628532365&width=600",
			"generalIndex": "998",
			"id": "zr-96-dna-clean-up-kit",
			"tags": [
				"enzymes-and-protein-expression",
				"protein-expression-and-purification",
			],
			filters: []
		},
		"ZR-96 DNA Clean & Concentrator-5 (Deep Well)": {
			"title": "ZR-96 DNA Clean & Concentrator-5 (Deep Well)",
			"catalogNumbers": "D4024, D4023",
			"description": "The ZR-96 DNA Clean & Concentrator-5 Kit is a 96 well PCR purification kit that provides rapid, large-scale (96-well) purification and concentration of high-quality DNA from PCR samples, endonuclease digestions, or crude plasmid preparations.",
			"handle": "/products/zr-96-dna-clean-amp-concentrator-5-deep-well",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/d4023_zr-96-dna-clean-and-concentrator-5.jpg?v=1628532420&width=600",
			"generalIndex": "998",
			"id": "zr-96-dna-clean-amp-concentrator-5-deep-well",
			"tags": [
				"enzymes-and-protein-expression",
				"protein-expression-and-purification",
			],
			filters: []
		},
		"Zymoclean Gel DNA Recovery Kit": {
			"title": "Zymoclean Gel DNA Recovery Kit",
			"catalogNumbers": "D4001, D4001T, D4002, D4007, D4008",
			"description": "The Zymoclean Gel DNA Recovery Kit is a gel DNA extraction kit that provides rapid purification of high quality DNA from TAE/TBE-buffered agarose gels.",
			"handle": "/products/zymoclean-gel-dna-recovery-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4001_Zymoclean-Gel-DNA-Recovery-Kit.jpg?v=1628532378&width=600",
			"generalIndex": "998",
			"id": "zymoclean-gel-dna-recovery-kit",
			"tags": [
				"enzymes-and-protein-expression",
				"protein-expression-and-purification",
			],
			filters: []
		},
		"ZR-96 Zymoclean Gel DNA Recovery Kit": {
			"title": "ZR-96 Zymoclean Gel DNA Recovery Kit",
			"catalogNumbers": "D4021, D4022",
			"description": "The ZR-96 Zymoclean Gel DNA Recovery Kit is a 96-well gel DNA extraction kit that provides rapid purification of high quality DNA from TAE/TBE-buffered agarose gels.",
			"handle": "/products/zr-96-zymoclean-gel-dna-recovery-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4021_ZR-96-Zymoclean-Gel-DNA-Recovery-Kit.jpg?v=1628532407&width=600",
			"generalIndex": "998",
			"id": "zr-96-zymoclean-gel-dna-recovery-kit",
			"tags": [
				"enzymes-and-protein-expression",
				"protein-expression-and-purification",
			],
			filters: []
		},
		"Zymoclean Large Fragment DNA Recovery": {
			"title": "Zymoclean Large Fragment DNA Recovery",
			"catalogNumbers": "D4045, D4046",
			"description": "The Zymoclean Large Fragment DNA Recovery Kit is a gel DNA extraction kit that provides a streamlined method for the rapid purification and concentration of high-quality large-sized DNA from agarose gels.",
			"handle": "/products/zymoclean-large-fragment-dna-recovery",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4045-Zymoclean-Large-Fragment-DNA-Recovery-Kit.jpg?v=1628532371&width=600",
			"generalIndex": "998",
			"id": "zymoclean-large-fragment-dna-recovery",
			"tags": [
				"enzymes-and-protein-expression",
				"protein-expression-and-purification",
			],
			filters: []
		},
		"ZymoPURE II Plasmid Midiprep Kit": {
			"title": "ZymoPURE II Plasmid Midiprep Kit",
			"catalogNumbers": "D4200, D4201",
			"description": "Part of the ZymoPURE Plasmid Kits collection, the ZymoPURE II Plasmid Midiprep kit provides the fastest and simplest method available to efficiently isolate up to 1.2 mg of transfection grade plasmid DNA from <i>E. coli</i>.",
			"handle": "/products/zymopure-ii-plasmid-midiprep-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4200_ZymoPURE-II-Plasmid-Midiprep-Kit.jpg?v=1639699365&width=600",
			"generalIndex": "998",
			"id": "zymopure-ii-plasmid-midiprep-kit",
			"tags": [
				"enzymes-and-protein-expression",
				"protein-expression-and-purification",
			],
			filters: []
		},
		"ZymoPURE 96 Plasmid Miniprep Kit": {
			"title": "ZymoPURE 96 Plasmid Miniprep Kit",
			"catalogNumbers": "D4214, D4215, D4216",
			"description": "The ZymoPURE™ 96 Plasmid Miniprep Kit features a high-throughput method for the purification of up to 100 µg of ultra-pure transfection-grade plasmid DNA using a vacuum manifold or centrifuge.",
			"handle": "/products/zymopure-96-plasmid-miniprep-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/files/D4214_D4215_ZymoPURE96Kit.jpg?v=1688420296&width=600",
			"generalIndex": "998",
			"id": "zymopure-96-plasmid-miniprep-kit",
			"tags": [
				"enzymes-and-protein-expression",
				"protein-expression-and-purification",
			],
			filters: []
		},
		"ZymoPURE II Plasmid Maxiprep Kit": {
			"title": "ZymoPURE II Plasmid Maxiprep Kit",
			"catalogNumbers": "D4202, D4203",
			"description": "Part of the ZymoPURE Plasmid Kits collection, the ZymoPURE II Plasmid Maxiprep kit provides the fastest and simplest method available to efficiently isolate up to 3 mg of transfection grade plasmid DNA from <i>E. coli</i>.",
			"handle": "/products/zymopure-ii-plasmid-maxiprep-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4202_ZymoPURE-II-Plasmid-Maxiprep-Kit.jpg?v=1639424233&width=600",
			"generalIndex": "998",
			"id": "zymopure-ii-plasmid-maxiprep-kit",
			"tags": [
				"enzymes-and-protein-expression",
				"protein-expression-and-purification",
			],
			filters: []
		},
		"ZymoPURE Plasmid Miniprep Kit": {
			"title": "ZymoPURE Plasmid Miniprep Kit",
			"catalogNumbers": "D4208T, D4209, D4210, D4211, D4212",
			"description": "Part of the ZymoPURE™ Plasmid Kits collection, the ZymoPURE™ Plasmid Miniprep Kit features a spin column-based method for the purification of up to 100 µg of ultra-pure endotoxin-free plasmid DNA in less than 15 minutes.",
			"handle": "/products/zymopure-ii-plasmid-miniprep-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4209_ZymoPURE-Plasmid-Miniprep-Kit.jpg?v=1639603106&width=600",
			"generalIndex": "998",
			"id": "zymopure-ii-plasmid-miniprep-kit",
			"tags": [
				"enzymes-and-protein-expression",
				"protein-expression-and-purification",
			],
			filters: []
		},
		"ZymoPURE II Plasmid Gigaprep Kit": {
			"title": "ZymoPURE II Plasmid Gigaprep Kit",
			"catalogNumbers": "D4204",
			"description": "Part of the ZymoPURE Plasmid Kits collection, the ZymoPURE II Plasmid Gigaprep kit provides the fastest and simplest method available to efficiently isolate up to 25 mg of transfection grade plasmid DNA from <i>E. coli</i>.",
			"handle": "/products/zymopure-ii-plasmid-gigaprep-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4204_ZymoPURE-II-Plasmid-Gigaprep-Kit.jpg?v=1639429337&width=600",
			"generalIndex": "998",
			"id": "zymopure-ii-plasmid-gigaprep-kit",
			"tags": [
				"enzymes-and-protein-expression",
				"protein-expression-and-purification",
			],
			filters: []
		},
		"ZymoPURE - Express Plasmid Midiprep Kit": {
			"title": "ZymoPURE - Express Plasmid Midiprep Kit",
			"catalogNumbers": "D4213",
			"description": "Part of the ZymoPURE Plasmid Kits collection, the ZymoPURE – Express Plasmid Midiprep kit utilizes a patented alkaline lysis method for purifying up to 1.2 mg of transfection-grade plasmid DNA directly from <i>E. coli</i> culture without conventional cell-pelleting and resuspension steps.",
			"handle": "/products/zymopure-express-plasmid-midiprep-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4213_ZymoPURE---Express-Plasmid-Midiprep-Kit.jpg?v=1639434343&width=600",
			"generalIndex": "998",
			"id": "zymopure-express-plasmid-midiprep-kit",
			"tags": [
				"enzymes-and-protein-expression",
				"protein-expression-and-purification",
			],
			filters: []
		},
		"Zyppy Plasmid Miniprep Kit": {
			"title": "Zyppy Plasmid Miniprep Kit",
			"catalogNumbers": "D4019, D4020, D4036, D4037",
			"description": "The Zyppy Plasmid Miniprep Kit is a plasmid DNA kit that features a pellet-free modified alkaline lysis system that bypasses the normal cell-pelleting and resuspension steps common to classical plasmid preparation procedures.",
			"handle": "/products/zyppy-plasmid-miniprep-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4019-Zyppy-Plasmid-Miniprep-Kit.jpg?v=1628532399&width=600",
			"generalIndex": "998",
			"id": "zyppy-plasmid-miniprep-kit",
			"tags": [
				"enzymes-and-protein-expression",
				"protein-expression-and-purification",
			],
			filters: []
		},
		"Zyppy-96 Plasmid Kit": {
			"title": "Zyppy-96 Plasmid Kit",
			"catalogNumbers": "D4041, D4042, D4043",
			"description": "The Zyppy-96 Plasmid Miniprep is the fastest and simplest high-throughput plasmid DNA kit available for efficient isolation of plasmid DNA from <i>E. coli</i>.",
			"handle": "/products/zyppy-96-plasmid-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4041_Zyppy-96-Plasmid-Miniprep.jpg?v=1628532398&width=600",
			"generalIndex": "998",
			"id": "zyppy-96-plasmid-kit",
			"tags": [
				"enzymes-and-protein-expression",
				"protein-expression-and-purification",
			],
			filters: []
		},
		"Zyppy-96 Plasmid MagBead Miniprep": {
			"title": "Zyppy-96 Plasmid MagBead Miniprep",
			"catalogNumbers": "D4100, D4101, D4102",
			"description": "The Zyppy-96 Plasmid MagBead Miniprep is the fastest high-throughput (96-well), Pellet-Free plasmid DNA kit available for efficient isolation of plasmid DNA from <i>E. coli</i>.",
			"handle": "/products/zyppy-96-plasmid-magbead-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4100_Zyppy-96-Plasmid-MagBead-Miniprep.png?v=1628532412&width=600",
			"generalIndex": "998",
			"id": "zyppy-96-plasmid-magbead-kit",
			"tags": [
				"enzymes-and-protein-expression",
				"protein-expression-and-purification",
			],
			filters: []
		},
		"ZR Plasmid Miniprep - Classic": {
			"title": "ZR Plasmid Miniprep - Classic",
			"catalogNumbers": "D4015, D4016, D4054",
			"description": "The ZR Plasmid Miniprep-Classic is designed for efficient isolation of plasmid DNA from <i>E. coli</i> using a traditional 3-buffer (P1, P2, P3) procedure that is simple, rapid, and reliable.",
			"handle": "/products/zr-plasmid-miniprep-classic",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4015_ZR-Plasmid-Miniprep-Classic-Kit.jpg?v=1628532396&width=600",
			"generalIndex": "998",
			"id": "zr-plasmid-miniprep-classic",
			"tags": [
				"enzymes-and-protein-expression",
			],
			filters: []
		},
		"ZR BAC DNA Miniprep Kit": {
			"title": "ZR BAC DNA Miniprep Kit",
			"catalogNumbers": "D4048, D4049",
			"description": "The ZR BAC DNA Miniprep Kit efficiently isolates BAC plasmid DNA or other large plasmids (e.g., PAC) from <i>E. coli</i> using a procedure that is simple, rapid, user-friendly, and reliable.",
			"handle": "/products/zr-bac-dna-miniprep-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4048_ZR-BAC-DNA-Miniprep-Kit.jpg?v=1628532399&width=600",
			"generalIndex": "998",
			"id": "zr-bac-dna-miniprep-kit",
			"tags": [
				"enzymes-and-protein-expression",
			],
			filters: []
		},
		"Zymoprep Yeast Plasmid Miniprep II": {
			"title": "Zymoprep Yeast Plasmid Miniprep II",
			"catalogNumbers": "D2004",
			"description": "The Zymoprep Yeast Plasmid Miniprep II is a simple and efficient yeast plasmid miniprep that is based on the <i>E. coli</i> alkaline lysis method but using Zymolyase as the first solution.",
			"handle": "/products/zymoprep-yeast-plasmid-miniprep-ii",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D2004_Zymoprep-Yeast-Plasmid-MiniPrep-II-Kit_aabbe60a-e5fb-44a8-b7b4-722047f23e24.jpg?v=1628532377&width=600",
			"generalIndex": "998",
			"id": "zymoprep-yeast-plasmid-miniprep-ii",
			"tags": [
				"enzymes-and-protein-expression",
				"protein-expression-and-purification",
			],
			filters: []
		},
		"Zymoprep Yeast Plasmid Miniprep I": {
			"title": "Zymoprep Yeast Plasmid Miniprep I",
			"catalogNumbers": "D2001",
			"description": "The Zymoprep Yeast Plasmid Miniprep I is a simple and efficient yeast plasmid miniprep that is based on the <i>E. coli</i> alkaline lysis method but using Zymolyase as the first solution.",
			"handle": "/products/zymoprep-yeast-plasmid-miniprep-i",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D2001_Zymoprep-Yeast-Plasmid-Miniprep-I-Kit_8b5581ce-6473-43b0-951d-d8f0a01bd259.jpg?v=1628532359&width=600",
			"generalIndex": "998",
			"id": "zymoprep-yeast-plasmid-miniprep-i",
			"tags": [
				"enzymes-and-protein-expression",
				"protein-expression-and-purification",
			],
			filters: []
		},
		"Zymoprep-96 Yeast Plasmid Miniprep": {
			"title": "Zymoprep-96 Yeast Plasmid Miniprep",
			"catalogNumbers": "D2005, D2006, D2007",
			"description": "The Zymoprep-96 Yeast Plasmid Miniprep kit provides all the necessary reagents for high-throughput plasmid isolation from <i>S. cerevisiae</i>, <i>C. albicans</i>, <i>S. pombe</i> and any fungi whose cell walls are susceptible to yeast lytic enzyme lysis.",
			"handle": "/products/zymoprep-96-yeast-plasmid-miniprep",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D2007_Zymoprep-96-Yeast-Plasmid-Miniprep-Kit_815aae83-fc83-4806-8e72-654cdf122053.jpg?v=1628532360&width=600",
			"generalIndex": "998",
			"id": "zymoprep-96-yeast-plasmid-miniprep",
			"tags": [
				"enzymes-and-protein-expression",
				"protein-expression-and-purification",
			],
			filters: []
		},
		"XJb (DE3) Autolysis Glycerol Stock": {
			"title": "XJb (DE3) Autolysis Glycerol Stock",
			"catalogNumbers": "T5051",
			"description": "While there are many cell lysis methods available to scientists, unfortunately none of these methods combine all the ideal features for simple, efficient, economical, and gentle lysis of <i>E. coli</i> cells.",
			"handle": "/collections/xj-autolysis-e-coli-strains/products/mix-and-go-competent-cells-xjbde3-autolysis",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/T5051_XJb_20DE3_20Autolysis_20-_20Glycerol_20Stock_20-_201_20ml.png?v=1628532420&width=600",
			"generalIndex": "998",
			"id": "mix-and-go-competent-cells-xjbde3-autolysis",
			"tags": [
				"protein-expression-and-purification",
			],
			filters: []
		},
		// "Endura Tn5 Transposase": {
		// 	"title": "Endura Tn5 Transposase",
		// 	"catalogNumbers": "E1024-20, E1024-100, E1025-20, E1025-100",
		// 	"description": "Endura™ Tn5 Transposase is hyperactive mutant of Tn5 Transposase with a proprietary formulation to confer superior stability, efficient tagmentation, and reliable consistency between experiments.",
		// 	"handle": "/products/endura-tn5-transposase-unloaded",
		// 	"navigation_image": "https://www.zymoresearch.com/cdn/shop/files/photo1_600x.webp?v=1750810168",
		// 	"generalIndex": "998",
		// 	"id": "endura-tn5-transposase-unloaded",
		// 	"tags": [
		// 		"transposases",
		// 		"enzymes-and-protein-expression",
		// 		"protein-enzymes"
		// 		// REMEMBER TO TURN PROTEIN AND ENZYMES INTO A FILTER PAGE
		// 	],
		// 	filters: []
		// },
	}
}